import React, {Component} from 'react';
import BackEnd from "../../../../backend/BackEnd";

class TenderListBase extends Component {
    loadingSpinner = <div className="text-center m-t-2">
        <i className="fa fa-circle-o-notch fa-spin fa-4x text-primary"/>
    </div>;

    searchCriteria = {};
    getCatalogs = new BackEnd.TenderOperator.GetCatalogs({
        start: () => this.setState({isLoading: true}),
        end: () => this.setState({isLoading: false})
    });

    async componentDidMount() {
        let catalogs = await this.getCatalogs.call();

        catalogs.payers.unshift({id: null, isDisabled: null, text: "Нет информации"});
        this.setState({...catalogs});

        await this.search();
    }

    async updatePageIndex(pageIndex) {
        await this.search(this.searchCriteria, pageIndex);
    }

    async search(criteria = this.searchCriteria, pageIndex = this.state.pageIndex) {
        this.searchCriteria = criteria;

        let result = await this.searchTenders.call({
            dto: {
                ...criteria,
                paging: {
                    pageIndex,
                    pageSize: this.props.pageSize
                }
            }
        });

        this.setState({pageIndex, ...result});
    }
}

export default TenderListBase;


// WEBPACK FOOTER //
// ./src/pages/TenderBlock/Tenders/components/TenderListBase.js